module.exports = __webpack_public_path__ + "10353a3a3124ce065ee713212bd753b7.png";